import type { ProductItem } from '@stickerapp-org/nomisma';

export const toJSON = (item: ProductItem) => {
  return {
    productFamilyName: item.getProductFamilyName(),
    productName: item.getProductName(),
    units: item.getAttribute('units'),
    attributes: { ...item.getAttributes() },
    sku: item.getAttribute('sku'),
  };
};
